import React from 'react';
import PropTypes from 'prop-types';

const Angle3Path = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 6C3.343 6 2 7.342 2 8.999V23a2.999 2.999 0 0 0 3 2.999h14A3 3 0 0 0 22 23V8.999A3 3 0 0 0 19 6H5zm3.327 5.975c.196-.471.504-.906.922-1.304a3.223 3.223 0 0 1 1.114-.648c.429-.149.957-.224 1.582-.224 1.162 0 2.098.298 2.81.892.712.596 1.069 1.395 1.069 2.397 0 .709-.213 1.307-.638 1.794-.268.305-.546.512-.837.623.218 0 .53.186.938.557.609.558.914 1.322.914 2.292 0 1.019-.357 1.914-1.069 2.686-.712.773-1.765 1.16-3.161 1.16-1.72 0-2.915-.558-3.585-1.671-.351-.591-.547-1.66-.586-2.619h2.345c0 .482.078 1.174.234 1.491.291.581.818.871 1.583.871.469 0 .878-.159 1.227-.477.349-.319.524-.777.524-1.375 0-.792-.324-1.32-.972-1.586-.368-.151-.949-.224-1.742-.224v-1.695c.776-.011 1.318-.086 1.625-.224.53-.233.796-.704.796-1.411 0-.46-.135-.835-.407-1.123-.27-.287-.652-.432-1.143-.432-.564 0-.979.178-1.243.532-.266.355-.393.543-.382 1.136H8.018c.022-.598.126-.881.309-1.418zm22.555-4.346l-6.627 3.726a.501.501 0 0 0-.255.436v8.415c0 .181.098.347.255.437l6.627 3.727A.75.75 0 0 0 32 23.717V8.281a.752.752 0 0 0-.751-.75.753.753 0 0 0-.367.098z"
    />
  );
};

Angle3Path.propTypes = {
  fill: PropTypes.string,
};

export default Angle3Path;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/angle-3.jsx